// constants for keys
export const ENABLED_ACCESS_TOKEN_STORE = 'ENABLED_ACCESS_TOKEN';
export const ENABLED_REFRESH_TOKEN_STORE = 'ENABLED_REFRESH_TOKEN';
export const ENABLED_EMAIL_STORE = 'ENABLED_USER';
export const ENABLED_ACCESS_EXPIRATION = 'ENABLED_ACCESS_EXPIRATION';
export const CUSTOM_CONTROLS_STORAGE = 'CUSTOM_CONTROLS';

// export const ENABLED_CLIENT_ID = "9a70d50a-3428-48dc-bc21-dc6807258aa4";
// export const getEnabledClientSecret = (): string => {
//     if(process.env.ENABLED_ENVIRONMENT == "dev") {
//         return "ZmZiNDUxOGM1ZGFiNDhlNmE5MjY2ZjBiYzliNDUxMmQ1OGExNDAxZjU0ZWI0ODU5YmRhN2VkYTc0OTA1M2M4Nw==";
//     }
//     else if (process.env.ENABLED_ENVIRONMENT == "staging") {
//         return "ZmZiNDUxOGM1ZGFiNDhlNmE5MjY2ZjBiYzliNDUxMmQ1OGExNDAxZjU0ZWI0ODU5YmRhN2VkYTc0OTA1M2M4Nw==";
//     }
//     else if (process.env.ENABLED_ENVIRONMENT == "production") {
//         return "ZmZiNDUxOGM1ZGFiNDhlNmE5MjY2ZjBiYzliNDUxMmQ1OGExNDAxZjU0ZWI0ODU5YmRhN2VkYTc0OTA1M2M4Nw==";
//     }

//     return null;
// }

export function createUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

export const getEnabledClientId = (): string => {
    if ((window as any).ADMIN_ENVIRONMENT) {
        return getAdminClientId();
    }
    if (!(window as any).WEB_ENVIRONMENT || (window as any).DESKTOP_ENVIRONMENT) {
        return '8b70d50a-3428-48dc-bc21-dc6807258aa4';
    }
    if ((window as any).ENABLED_ENVIRONMENT == 'dev') {
        return 'bc55094d-6cea-446e-a44a-e61c9d2c07e2';
    }
    if ((window as any).ENABLED_ENVIRONMENT == 'beta') {
        return 'cc55094d-6cea-446e-a44a-e61c9d2c07e2';
    }
    return '8b70d50a-3428-48dc-bc21-dc6807258aa4'; // production
};

export const getEnabledClientSecret = (): string => {
    if ((window as any).ADMIN_ENVIRONMENT) {
        return getAdminClientSecret();
    }
    if (!(window as any).WEB_ENVIRONMENT || (window as any).DESKTOP_ENVIRONMENT) {
        return 'AmZiNDUxOGM1ZGFiNDhlNmE5MjY2ZjBiYzliNDUxMmQ1OGExZDAxZjU0ZWI0ODU5YmRhN2VkYTc0OTA1M2M4Nw==';
    }
    if ((window as any).ENABLED_ENVIRONMENT == 'dev') {
        return 'Fg709dBr0DMOxlWDIfX27gJKDCQz5TnfyVkUh8WzM7YCpmmPM37j3UQtkal1';
    }
    if ((window as any).ENABLED_ENVIRONMENT == 'beta') {
        return 'Fg709dBr0DMOxlWDIfX27gJKDCQz5TnfyVkUh8WzM7YCpmmPM37j3UQtkal1';
    }
    return 'AmZiNDUxOGM1ZGFiNDhlNmE5MjY2ZjBiYzliNDUxMmQ1OGExZDAxZjU0ZWI0ODU5YmRhN2VkYTc0OTA1M2M4Nw=='; // production
};

const getAdminClientId = (): string => {
    const environment = process.env.ENABLED_ENVIRONMENT || 'production';
    if (environment == 'dev') {
        return 'a2409dc9-b495-4b14-ac38-6c288b7871bd';
    }
    if (environment == 'staging') {
        return 'a2409dc9-b495-4b14-ac38-6c288b7871bd';
    }
    if (environment == 'beta') {
        return 'a2409dc9-b495-4b14-ac38-6c288b7871bd';
    }
    if (environment == 'staging-local') {
        return 'a2409dc9-b495-4b14-ac38-6c288b7871bd';
    }
    return '3c8de27c-e1d7-4565-a4f2-e5de5f5a0e63'; // production
};

const getAdminClientSecret = (): string => {
    const environment = process.env.ENABLED_ENVIRONMENT || 'production';
    if (environment == 'production') {
        return 'V7xGFh85f0FlwKN5WWmPfgWHrrrGy96WV6QM4jisQA46SQkUmRF5xIdaJEg0ftlv';
    }
    if (environment == 'dev') {
        return 'MftKwkGoysYJjTMnZo2Greym7jf0gQpu 2Ry4tpZBLuGkQU83WXl0Qb4cYkqS273O';
    }
    if (environment == 'staging') {
        return 'MftKwkGoysYJjTMnZo2Greym7jf0gQpu 2Ry4tpZBLuGkQU83WXl0Qb4cYkqS273O';
    }
    if (environment == 'beta') {
        return 'MftKwkGoysYJjTMnZo2Greym7jf0gQpu 2Ry4tpZBLuGkQU83WXl0Qb4cYkqS273O';
    }
    if (environment == 'staging-local') {
        return 'MftKwkGoysYJjTMnZo2Greym7jf0gQpu 2Ry4tpZBLuGkQU83WXl0Qb4cYkqS273O';
    }
    return 'V7xGFh85f0FlwKN5WWmPfgWHrrrGy96WV6QM4jisQA46SQkUmRF5xIdaJEg0ftlv'; // production
};
